import { createRegisterableComponent } from '@news-mono/web-common'
import React from 'react'
import { TNAppDownloadPage } from './TNAppDownloadPage'

export const TNAppDownloadPageRegistration = createRegisterableComponent(
    'tn-app-download-page',
    () => <TNAppDownloadPage />,
)
